import { loginRequest } from "./AuthorizationConfig";
import MsalInstance, { msalInit } from "./AuthorizationProvider";

export const getActiveAccount = async () => {
  await msalInit;
  const account = MsalInstance.getActiveAccount();
  if (account) return account;

  const accounts = MsalInstance.getAllAccounts();
  if (accounts.length > 0) {
    MsalInstance.setActiveAccount(accounts[0]);
    return accounts[0];
  }
  return null;
};

const acquireTokenSilently = async (account: any) => {
  try {
    const response = await MsalInstance.acquireTokenSilent({
      ...loginRequest,
      account: account,
    });
    return response.accessToken;
  } catch (error) {
    console.log('Silent token acquisition failed', error);
    return null;
  }
};

const acquireTokenInteractively = async () => {
  try {
    const response = await MsalInstance.acquireTokenPopup(loginRequest);
    return response.accessToken;
  } catch (error) {
    console.error('Failed to acquire token interactively', error);
    return null;
  }
};

export const getToken = async (): Promise<string | null> => {
  try {
    const account = await getActiveAccount();
    if (!account) return null;

    const silentToken = await acquireTokenSilently(account);
    if (silentToken) return silentToken;

    return await acquireTokenInteractively();
  } catch (error) {
    console.error("Token acquisition error:", error);
    return null;
  }
};

export const getUserRoles = async (): Promise<string[] | null> => {
  try {
    const account = await getActiveAccount();
    if (!account) return null;

    const idTokenClaims = account.idTokenClaims;
    if (idTokenClaims?.roles && Array.isArray(idTokenClaims.roles)) {
      console.log("Found roles in ID token:", idTokenClaims.roles);
      return idTokenClaims.roles;
    }

    console.warn("No roles found in ID token claims");
    return null;
  } catch (error) {
    console.error("Error getting user roles:", error);
    return null;
  }
};
